//import React from 'react';
import Box from "@mui/material/Box";
const logo = require('../images/banner.png'); 
import ReactDOM, { Link } from "react-router-dom";
import Typography from '@mui/material/Typography';
var Config = require('../config.json')


const TopPublicNavigation = (props) => {
	
  return (
  <>
  <Typography
            variant="h8"
            noWrap
            component="a"
          
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
		  {Config.sub_title} 
          </Typography>
  </>
  );
};

export default TopPublicNavigation;